import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import accessory23 from "../../Assets/accessory23.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav } from "react-bootstrap";
import "../../App.css";

const Greenhouse_Pipe_Saddle_Clamp = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 69,
      name: "Greenhouse Pipe Saddle Clamp",
      price: 250,
      image: accessory23,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <img
            src={accessory23}
            alt="Poly House Gutter Plate"
            className="d-block w-100"
          />
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Greenhouse Pipe Saddle Clamp</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>
            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  The Greenhouse Pipe Saddle Clamp is used to secure pipes onto
                  flat surfaces or other pipes in a greenhouse structure. This
                  accessory is vital for fixing the greenhouse skeleton,
                  ensuring a sturdy and reliable frame.
                </p>
                <i>Note: Minimum Order Quantity: 1000 Units.</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Material:</span>Galvanized Iron
                      (GI)
                    </li>
                    <li>
                      <span className="fw-bold">Size:</span> Available in
                      multiple diameters to fit various pipe sizes
                    </li>
                    <li>
                      <span className="fw-bold">Design:</span> Saddle-shaped
                      with pre-drilled holes for bolts or screws
                    </li>

                    <li>
                      <span className="fw-bold">Brand:</span> RGCPL
                    </li>
                    <li>
                      <span className="fw-bold">Durability:</span> 7-8 Years
                    </li>
                    <li>
                      <span className="fw-bold">Minimum Order Quantity:</span>{" "}
                      500 pieces
                    </li>
                  </ul>
                </p>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Corrosion-resistant: Zinc-coated to prevent rust and prolong
                    its lifespan.
                  </li>
                  <li>
                    Firm Hold: The saddle design hugs the pipe securely,
                    ensuring no movement.
                  </li>
                  <li>
                    Pre-drilled Holes: Simplifies the process of bolting it to
                    the structure.
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <p>
                  <ul>
                    <li>
                      <span className="fw-bold">Item Code:</span> RGCPL-0023
                    </li>
                    <li>
                      <span className="fw-bold">Delivery Time:</span> 7-8 Days
                    </li>
                    <li>
                      <span className="fw-bold">Port of Dispatch:</span>{" "}
                      Maharashtra, India
                    </li>
                    <li>
                      <span className="fw-bold">Production Capacity:</span> 1000
                      Pieces Per Day
                    </li>
                    <li>
                      <span className="fw-bold">Packaging Details:</span> Large
                      Bags
                    </li>
                    <li>
                      <span className="fw-bold">Payment Terms:</span> Advance
                      Payment
                    </li>
                    <li>
                      <span className="fw-bold">Payment Mode:</span> RTGS / NEFT
                      / IMPS
                    </li>
                  </ul>
                </p>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Importance of Greenhouse Pipe Saddle Clamp:</h5>
        <p className="text-justify">
          <ul>
            <li>
              Pipe Stabilization: Ensures pipes are securely mounted, providing
              stability to the greenhouse structure.
            </li>
            <li>
              Flexibility in Structure: Enables greenhouse builders to add more
              layers or support pipes for structural strength.
            </li>
            <li>
              Safety: Reduces the risk of pipe movement, ensuring a safe and
              strong greenhouse framework even in windy or high-pressure
              environments.
            </li>
          </ul>{" "}
        </p>

        <h5 className="mt-3">Applications of Greenhouse Pipe Saddle Clamp:</h5>
        <p className="text-justify">
          <ul>
            <li>
              Used for securing pipes in greenhouses, shade houses, and
              polyhouses to maintain a strong structural framework.
            </li>
          </ul>
        </p>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Greenhouse_Pipe_Saddle_Clamp;
